import { forwardRef, Ref } from 'react';
import { SimpleTreeView as MuiTreeView, TreeViewProps as MuiTreeViewProps } from '@mui/x-tree-view';

export interface TreeViewProps<T extends boolean | undefined> extends MuiTreeViewProps<T> {}

const TreeView = forwardRef(<T extends boolean | undefined>(props: TreeViewProps<T>, ref: Ref<HTMLUListElement>) => (
  <MuiTreeView ref={ref} {...props} />
));

TreeView.displayName = 'TreeView';

export default TreeView;
